import React, {Component, Fragment} from 'react';
import * as invoices from 'invoices/actions/invoices';
import {connect} from 'react-redux';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Search from 'invoices/Search';
import NewInvoice from 'invoices/containers/NewInvoice';
import {invoiceListColumns} from 'invoices/InvoiceListColumns';
import autobind from 'autobind-decorator';
import Loading from 'apa/components/Loading';
import {Col, FormGroup} from 'reactstrap';
import InvoiceContainer from 'invoices/containers/InvoiceContainer';

export const INVOICE_TYPE = [
    'Ausstehend',
    'Bezahlt'
];

@connect(
    state => {
        return {
            invoices: state.invoices,
        }
    },
    dispatch => {
        return {
            fetchInvoices: () => {
                dispatch(invoices.fetchInvoices());
            },
            changePage: (page) => {
                dispatch(invoices.changePage(page));
            },
        }
    }
)
export default class InvoiceList extends Component {

    componentDidMount() {
        this.props.fetchInvoices();
    }

    @autobind
    onTableChange(type, {page}) {
        if (type === 'pagination') {
            this.props.changePage(page)
        }
    }

    render() {
        const {invoiceListIsLoading} = this.props.invoices;
        if (invoiceListIsLoading) {
            return <Loading/>
        } else {
            const {
                invoiceList,
                totalCount,
                sizePerPage,
                currentPage
            } = this.props.invoices;
            return (
                <InvoiceContainer>
                    <Fragment>
                        <FormGroup row className='mt-3'>
                            <Col sm={3}>
                                <Search/>
                            </Col>
                            <Col sm={3}>
                                <NewInvoice/>
                            </Col>
                        </FormGroup>
                        <BootstrapTable
                            remote
                            keyField='id'
                            data={invoiceList}
                            columns={invoiceListColumns}
                            pagination={
                                paginationFactory(
                                    {
                                        page: currentPage,
                                        sizePerPage: sizePerPage,
                                        totalSize: totalCount
                                    }
                                )
                            }
                            onTableChange={this.onTableChange}
                            striped
                            bootstrap4
                            responsive
                        />
                    </Fragment>
                </InvoiceContainer>
            )
        }

    }

}

